import { useStats } from '../api/client';

const ORDER = [
  ['item', 'items'],
  ['npc', 'NPCs'],
  ['quest', 'quests'],
  ['object', 'objects'],
  ['zone', 'zones'],
  ['recipe', 'recipes'],
  ['ability', 'class abilities'],
] as const;

/** Site-wide counts; `tiny` renders it in the 2009 landing page's 60% type. */
export function StatsLine({ tiny = false }: { tiny?: boolean }) {
  const stats = useStats();
  const cls = tiny ? 'stats-line tiny' : 'stats-line';
  if (!stats.data) return <p className={`${cls} muted`}>Loading...</p>;
  const parts = ORDER.map(
    ([key, label]) => `${stats.data.artifacts[key].toLocaleString()} ${label}`,
  );
  return (
    <p className={cls} data-testid="stats-line">
      {parts.join(', ')} and {stats.data.screenshots.toLocaleString()} screenshots
    </p>
  );
}
